export default  {
    name: "Average Daily Traffic Counts",
    mapLayerIcon: "",
    defaultOn: false,
    showOnMap: true,
    wmsMapLayer: "cdot:congestionadt",
    wmsPublish: "tasWebapp.congestion.segments.publishing"
}